export default "__VITE_ASSET__D1Udu7CP__"